// extracted by mini-css-extract-plugin
export default {"main":"_845349ce75","tit":"_47c8c4f80d","maintitle":"_9280e9f5ee","ylw":"a5d068c57e","white":"_2c3e8112bd","mv_title":"_84b7ff1f96","mv_nc":"e17b11efbd","mv_in":"bb56a559a1"};